export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value
  const hash = to.params.hash

  try {
    const response: { status: string, email: string } = await $fetch(`${useBaseUrl()}/user-by-hash/${hash}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if(!response?.email) {
      return navigateTo(`/${locale}`)
    }
  } catch (error) {
    console.error('Error fetching user by hash:', error)
    return navigateTo(`/${locale}`)
  }

})